import { useNavigation } from 'react-router-dom';

import { TopProgressBar } from '@spacefill/uikit/src/components/TopProgressBar';

import { usePendingRequestsCount } from '../hooks/usePendingRequestsCount';

export const GlobalLoadingBar = () => {
    const pendingRequestsCount = usePendingRequestsCount();
    const navigation = useNavigation();

    return <TopProgressBar isActive={pendingRequestsCount > 0 || navigation.state !== 'idle'} />;
};
